import { CalendarComponentOptions } from 'ion2-calendar'
import { Ortak } from '../../../providers/ortak';
import { BllOrtak } from '../../../providers/bll/bll-ortak';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
declare var cordova: any;

@Component({
  selector: 'page-urun-satis-raporu',
  templateUrl: 'urun-satis-raporu.html',
})
export class UrunSatisRaporuPage {
  @ViewChild('sideNavUrunAra') sideNav;
  urunListesi = [];
  tarih1: any;
  tarih2: any;
  satistoplami:number=0;
  dateRange: {
    from: Date
    to: Date
  } = {
      from: this.tarih1,
      to: this.tarih2
    };
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  optionsRange: CalendarComponentOptions = {
    from: new Date(2016, 1, 1),
    pickMode: 'range',
    color: "danger",
    monthPickerFormat: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Tem", "Agust", "Eylül", "Ekim", "Kasım", "Aralık"]
  };
  istektarihi :any;
  cihazid = "";
  aranan="";
  toplamsatis:number=0;
  ServerParamet: any = { FirmaAdi: "", FirmaTelefonu: "", FirmaAdres: "", FirmaEmail: "", FirmaWeb: "", FirmaVD: "", FirmaVN: "" };
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public navParams: NavParams) {
  


  }

  ionViewDidLoad() {
    this.dateRange.from = this.ortak.storageGunTarihiGetir;
    this.dateRange.to = this.ortak.storageGunTarihiGetir;
    this.RaporuGetir();
    this.closeNav();

  }
  parametrelerial() {
    this.bllOrtak.islemWithoutPost("ParametreleriVer", "", false).then(a => {
      var sonuc = <any>a;
      this.ServerParamet = sonuc.SonucObject;
    });

  }
  RaporuGetir() {
    var formData = new FormData();
    formData.append("tarih1", this.ortak.tarih(this.dateRange.from));
    formData.append("tarih2", this.ortak.tarih(this.dateRange.to));
    formData.append("aranan",this.aranan);
    this.bllOrtak.islem(formData, "UrunSatisRaporu", "", true).then(a => {
      var sonuc = <any>a;
        this.urunListesi = sonuc.SonucObject;
        this.urunListesi.forEach(e=>{
          this.toplamsatis+=e.Tutar;
        })

      this.closeNav();
  
   
    });
  }



  urunler(e) {
    if (e.keyCode == 13) {
      this.RaporuGetir();
    }
  }
  openNav() {
    let sideElement = this.sideNav.nativeElement
    sideElement.style.display = "block";
  }
  closeNav() {
    let sideElement = this.sideNav.nativeElement;
    sideElement.style.display = "none";
  }
  pdf() {
    var html = "<html><head>  <link href='https://stackpath.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css' rel='stylesheet'></head><body>" +
      "<table style='width: 100%;border-bottom:1px solid lightgray;margin-bottom:30px'>" +
      "<tbody>" +
      "<tr>" +
      "<td style'width: 41.8357%;'>&nbsp;</td>" +
      "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'> {{ServerParamet.FirmaAdres}}</span></td>" +
      "</tr>" +
      "<tr>" +
      "<td style='width: 41.8357%;'>&nbsp;<span style='color: #cc0000;'><strong style='font-size: 30px;'><strong>{{ServerParamet.FirmaAdi}}</strong></strong></span></td>" +
      "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'> {{ServerParamet.FirmaTelefonu}}</span></td>" +
      "</tr>" +
      "<tr>" +
      "<td style='width: 41.8357%;'>&nbsp;</td>" +
      "<td style='width: 53.1643%;'><span style='float:left;width:100%;text-align:right'> {{ServeParamet.FirmaWeb}}</span></td>" +
      "</tr>" +
      "</tbody>" +
      "</table>" +
      "<div class='card text-center'>" +
      "<div class='card-footer text-muted'>" +
      "Ürün Satış Raporu" +
      "</div>" +
      "</div><hr/>" +
      "<table class='table table-striped table-bordered table-hover'>" +
      "<thead>" +
      "<tr>" +
      "<th>Stok Adı</th>" +
      "<th>Miktar</th>" +
      "<th>Tutar</th>" +

      "</tr>" +
      "</thead>" +
      "<tbody>";
    this.urunListesi.forEach(extre => {
      html = html + "<tr>";
      html = html + "<td>" + extre.StokAdi + "</td>";
      html = html + "<td>" + extre.Miktar + "</td>";
      html = html + "<td>" + extre.Tutar.toFixed(2) + "</td>";

      html = html + "</tr>";
    });
    html = html + "<table style='width:100%'>";
    html = html + "<tr>";
    html = html + "<td>";
    html = html + "<span style='float:left;width:100%;text-align:right'>Toplam Satış Tutarı: " + this.toplamsatis.toFixed(2) + " </span>";
    html = html + "</td>";
    html = html + "</tr>";
    html = html + "</table>";
    html = html + "</body></html>";
    html = html + "</tbody></table></body></html>";
    cordova.plugins.pdf.htmlToPDF({
      data: html,
      documentSize: "A4",
      landscape: "portrait",
      type: "share"
    },
      (sucess) => console.log('sucess: ', sucess),
      (error) => console.log('error:', error));
  }
  excel() {
    var data = [];
    this.urunListesi.forEach(element => {
      data.push({
        "Stok Adı": element.StokAdi,
        "Miktar": element.Miktar,
        "Tutar": element.Tutar,

      })
    });
    this.ortak.ExportExcel(data, "Ürün S.Raporu-" + this.istektarihi).then(a => {
    }).catch(x => {
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/Raporlars/urun-satis-raporu/urun-satis-raporu.ts